var translations = {
    male: 'Mann',
    female: 'Kvinne',
    none: 'Jeg ønsker ikke å svare',

    student: 'Student',
    worker: 'Jobber',
    retired: 'Pensjonist',
    other: 'Annet',

    habits: 'For å sjekke mine drikkevaner',
    fun: 'Bare for moroskyld, har ikke gitt helt ærlige svar',

};
  
export default translations;